"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvFeature = void 0;
class EnvFeature {
    businessUnits;
    releasedInProduction;
    constructor({ businessUnits, isInProduction }) {
        this.businessUnits = new Set(businessUnits);
        this.releasedInProduction =
            typeof isInProduction === 'boolean' ? new Set(isInProduction ? this.businessUnits : []) : new Set(isInProduction);
    }
    isEnabled({ businessUnit, isProduction }) {
        if (!this.businessUnits.has(businessUnit)) {
            return false;
        }
        return !isProduction || this.releasedInProduction.has(businessUnit);
    }
}
exports.EnvFeature = EnvFeature;
